/**
 * useMetrics Hook
 * Obtiene métricas del agente con polling periódico
 */

import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';
import type { AgentMetrics } from '@/types/metrics';

export const useMetrics = (agentId: string | null) => {
  return useQuery({
    queryKey: ['metrics', agentId],
    queryFn: async () => {
      if (!agentId) throw new Error('Agent ID required');
      const { data } = await apiClient.get<AgentMetrics>(`/agents/${agentId}/metrics`);
      return data;
    },
    refetchInterval: 10000, // Poll cada 10s (WS empuja el dato en vivo; esto es fallback)
    refetchIntervalInBackground: false, // No pollear con la pestaña oculta
    enabled: !!agentId,
  });
};
